export default `
  query listConnectedMcpClients {
    listConnectedMcpClients {
      clientId
      clientName
      scope
      connectedAt
    }
  }
`
